import React from "react";
import Modal from "react-modal";
import { PrimaryActionButton } from "../PrimaryActionButton/PrimaryActionButton";
import { MailchimpTrialForm } from "../MailchimpTrialForm/MailchimpTrialForm";
import { useTranslation } from "react-i18next";

export function TrialModalButton(props) {
    const { t } = useTranslation();

    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const openModal = () => {
        setModalIsOpen(true);
        document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
        setModalIsOpen(false);
        document.body.style.overflow = "auto";
    };

    return (
        <div className="flex items-center justify-center">
            <PrimaryActionButton
                label={t("cta-trial-button-label")}
                onClick={openModal}
                className={`!bg-[#242D29] hover:!bg-[#48554F] !text-[14px] h-16 w-auto max-w-lg ${
                    props.className ? props.className : ""
                }`}
            />
            <Modal
                className="bg-white h-auto max-h-[80%] min-w-2/5 max-w-[90%] rounded-3xl overflow-y-auto overflow-x-hidden md:max-w-screen-md"
                overlayClassName="overlay"
                appElement={document.getElementById("root") || undefined}
                closeTimeoutMS={100}
                shouldCloseOnOverlayClick={true}
                onRequestClose={() => closeModal()}
                isOpen={modalIsOpen}
            >
                <MailchimpTrialForm className="text-black flex flex-col mx-10 mt-2 mb-10 md:mx-16" />
            </Modal>
        </div>
    );
}
